import React from 'react';
import { Button } from '../components/Button';
import { Bulbs } from '../components/layout/V5Chrome';
export function NotFound() {
  return <section className="tis-hero flex min-h-[78vh] flex-col items-center justify-center" data-id="element-417" data-mp="w4jal1haegag">
      <div className="ghost" aria-hidden="true" data-id="element-418" data-mp="104be2zrtpw8y">
        404
      </div>
      <Bulbs n={7} data-id="element-419" data-mp="1560p4ff1q9x1" />
      <span className="tis-eyebrow" data-id="element-420" data-mp="156iv43rig2i5">Wrong turn on the Strip</span>
      <h1 className="tis-title tis-neon" data-id="element-421" data-mp="1a4k9wchwlfnt">Page Not Found</h1>
      <p className="tis-sub" data-id="element-422" data-mp="1a27xeeuwzxi5">The page you are looking for does not exist or has moved.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-423" data-mp="1f10zlb4r4230">
        <Button to="/" data-id="element-424" data-mp="1juwxkdl0loy6">Back to home</Button>
        <Button to="/book-now" variant="outline" data-id="element-425" data-mp="1jw7y84j5ygl2">
          Book your full day
        </Button>
      </div>
    </section>;
}